import { HostListener, Directive, OnChanges, Self,  } from "@angular/core";
import { AbstractControl,  NgControl } from "@angular/forms";


@Directive({
  selector: '[onBlurValidator]'
})
export class OnBlurValidatorDirective  implements OnChanges {

  private asyncValidators: any;
  private wasChanged: any;


  control:AbstractControl;

  constructor(@Self() private _control: NgControl) {
      this.control=_control.control;
  }

  // On focus of control, clear all async validators so they do not fire on keypress
  @HostListener('focus', ['$event'])
  onFocus($event:any) {
      this.wasChanged = false;
      this.asyncValidators = this.control.asyncValidator;
      this.control.clearAsyncValidators();
  }

  @HostListener('window:keyup', ['$event'])
  onKeyup($event:any) {
      this.wasChanged = true;
  }

  ngOnChanges() {
      this.wasChanged = true;
  }

  private updatePending: boolean = false;
  // On blur of control, re-enable all async validators so they fire 
  @HostListener('blur', ['$event'])
  onBlur($event:any) {
    this.control.setAsyncValidators(this.asyncValidators);
    if (this.wasChanged && !this.updatePending) {
        this.updatePending = true; //si le validator force une modification de la valeur (suppresion des blnces siret ou intra tva par ex, on va boucler sans ce controle interne)
        this.control.updateValueAndValidity();
        this.updatePending = false;
        this.wasChanged = false;
    }
  }
}
